{
    "UserTour_Next": "Avanti",
    "UserTour_Cancel": "Mostrami più tardi",
    "UserTour_Exit": "Disattivare il tour",
    "NAME": "UserTour"
}